import { createStore } from "vuex";
import functionalities from "@/store/modules/functionalities";
import translation from "@/store/modules/translation";
import clickEvents from "@/store/modules/clickEvents";
import auth from '@/store/auth'
export default createStore({
  state: {
      /* baseUrl: process.env.VUE_APP_URL_API_BASE, */
      baseUrl: process.env.VUE_APP_URL_BASE_API,
      isLoading: false
  },
  mutations: {
      setLoading(state, newLoadingState) {
          state.isLoading = newLoadingState
      }
  },
  getters: {
      getLoading: (state) => {
          return state.isLoading
      }
  },
  actions: {},
  modules: {
    functionalities,
    translation,
    clickEvents,
    auth
    
  },
});
